.Overlay {
  overflow: auto;
}
